export default __webpack_public_path__ + "static/media/oludotun.dfe46248.png";